import React from 'react'
import {TickCircleIcon, PhoneIcon, Pane, Strong, Text, WarningSignIcon } from 'evergreen-ui'
import { connect } from 'react-redux'
import { getCurrency } from '../util'

const BookingConfirmationDialogContent = props => {
  const {
    bookingData,
    selectedCourt,
    cartSummary,
    cart,
    customerMobile,
    count,
    activityType
  } = props

  const paidAmount = bookingData['bookings'].reduce((accumulator, booking) => {
    accumulator += booking['price'] + booking['credits']
    return accumulator
  }, 0)
  let slots = cart && cart.slots && cart.slots.length * count
  return (
    <Pane
      display={'flex'}
    
      justifyContent={'flex-start'}
      flexDirection={'column'}
      paddingRight={20}
    >
      <Pane
        display={'flex'}
        flexBasis={'100%'}
        justifyContent={'space-between'}
        marginTop={10}
        height={200}
        marginBottom={10}
      >
        <Strong> {bookingData['bookingId']}</Strong>
        <Pane display={'flex'} flexDirection='row' justifyContent={'flex-end'}>
          <div className={'solid-icon-container'}>
            <PhoneIcon size={8} color="white" />
          </div>
          <Strong
            is='a'
            href={`tel:${customerMobile}`}
            className={'no-underline'}
          >
            {customerMobile}
          </Strong>
        </Pane>
      </Pane>
      <Pane
        display={'flex'}
        flexBasis={'100%'}
        justifyContent={'space-between'}
        marginTop={10}
        marginBottom={10}
      >
        <Text>{cartSummary['activityName']}</Text>
        <Text>
          {selectedCourt.courtName} {activityType === 1 && `| ${slots} slot(s)`}
        </Text>
      </Pane>
      <Pane
        display={'flex'}
        flexBasis={'100%'}
        justifyContent={'space-between'}
        marginBottom={10}
      >
        <Pane
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'center'}
        >
          <Text>{cartSummary['date']}</Text>
          <Text>{cartSummary['slots']}</Text>
        </Pane>
        <Pane
          hight={32}
          display={'flex'}
          flexDirection={'row'}
          justifyContent={'space-evenly'}
          alignItems={'center'}
        >
          {paidAmount === cart.cartPrice * count ? (
            <TickCircleIcon color="success" marginRight={5} />
          ) : (
            <WarningSignIcon color="warning" marginRight={5} />
          )}
          <Strong
            color={
              paidAmount === cart.cartPrice * count ? 'success' : 'warning'
            }
          >
            {`${getCurrency()} ${paidAmount} / ${cart.cartPrice * count}`}
          </Strong>
        </Pane>
      </Pane>
    </Pane>
  )
}

const mapStateToProps = ({ bookingData, cart }) => ({
  bookingData,
  cart
})

export default connect(mapStateToProps)(BookingConfirmationDialogContent)
